import(/* webpackMode: "eager" */ "/opt/buildhome/repo/fronted/app/login/page.tsx");
